import { render, staticRenderFns } from "./Peking.vue?vue&type=template&id=57089e06&scoped=true&"
import script from "./Peking.vue?vue&type=script&lang=js&"
export * from "./Peking.vue?vue&type=script&lang=js&"
import style0 from "./Peking.vue?vue&type=style&index=0&id=57089e06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57089e06",
  null
  
)

export default component.exports